import axios from "axios";

export function getRegistrationChangeLogs(registrationid) {
  return axios
    .get(process.env.REACT_APP_API + "/admin/registration-change-log/" + registrationid)
    .then((resp) => resp.data);
}
